import { useEffect } from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom"


import CreatePricingContract from "../PricingContracts/CreatePricingContract.js"
import EditPricingContract from "../PricingContracts/EditPricingContract.js"





export default function PricingContracts() {

    return (
        <Routes>
            <Route path="/create/" element={<CreatePricingContract />} />
            <Route path="/edit/:id" element={<EditPricingContract />} />
        </Routes>
    )
}


